<template>
  <button
    type="button"
    class="relative overflow-hidden w-full flex flex-col gap-1 text-left cursor-pointer border-none rounded-md mb-2 px-3.5 py-3 bg-soft-yellow text-gray-900 shadow-md transition-all duration-150 ease-in-out hover:-translate-y-px hover:shadow-lg"
    @click="$emit('click')"
  >
    <span class="challenge-shine absolute top-0 pointer-events-none h-full" aria-hidden="true"></span>

    <span class="relative flex items-center gap-2">
      <svg
        class="challenge-flame shrink-0"
        viewBox="0 0 24 24"
        width="18"
        height="18"
        fill="none"
        stroke="currentColor"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true"
      >
        <path
          d="M12 3c.6 3-1.5 4.2-2.7 5.7C8 10.2 7 11.7 7 13.8 7 17 9.2 19 12 19s5-2 5-5.2c0-2.4-1.3-4-2.5-5.4C13.6 7.2 13 5.4 12 3z"
        />
        <path d="M12 19c-1.5 0-2.6-1.1-2.6-2.6 0-1.6 1.3-2.3 1.7-3.4.6 1 2 1.6 2 3.2C13.1 17.6 12.7 19 12 19z" />
      </svg>
      <span class="text-[13px] font-extrabold tracking-tight whitespace-nowrap">{{ t("title") }}</span>
    </span>

    <span class="relative text-[11px] font-semibold text-gray-700 pl-2 whitespace-nowrap">
      {{ t("subtitle", { maxBonus }) }}
    </span>
  </button>
</template>

<script>
import { useI18n } from "vue-i18n";
import { getMaxBonusPerSeller } from "@/utils/saturdayChallenge";

export default {
  props: {
    maxBonus: {
      type: Number,
      default: () => getMaxBonusPerSeller(),
    },
  },
  emits: ["click"],
  setup() {
    const { t } = useI18n();
    return { t };
  },
};
</script>

<i18n src="./SaturdayChallengeButton.i18n.json"></i18n>

<style scoped>
.challenge-flame {
  color: #e8400e;
  animation: challenge-flicker 1.5s ease-in-out infinite;
  transform-origin: 50% 80%;
}

.challenge-shine {
  left: -60%;
  width: 45%;
  background: linear-gradient(100deg, transparent, rgb(255 255 255 / 0.75), transparent);
  transform: skewX(-18deg);
  animation: challenge-shimmer 3.4s ease-in-out infinite;
}

@keyframes challenge-shimmer {
  0% {
    left: -60%;
  }
  60%,
  100% {
    left: 130%;
  }
}

@keyframes challenge-flicker {
  0%,
  100% {
    transform: scale(1) rotate(0deg);
    opacity: 1;
  }
  25% {
    transform: scale(1.12) rotate(-4deg);
    opacity: 0.92;
  }
  50% {
    transform: scale(0.96) rotate(3deg);
    opacity: 1;
  }
  75% {
    transform: scale(1.08) rotate(-2deg);
    opacity: 0.95;
  }
}

@media (prefers-reduced-motion: reduce) {
  .challenge-shine,
  .challenge-flame {
    animation: none;
  }
}
</style>
